// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import axios from "axios";
// import lgnBg from "../../Assets/Login/bgcolor.jpg";
// import logo from "../../Assets/Logos/logov.png";
// import { Eye, EyeOff } from "lucide-react";

// const Login = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [errors, setErrors] = useState({
//     email: "",
//     password: "",
//   });

//   const showToast = (msg, type = "error") => {
//     toast[type](msg, {
//       position: "top-center",
//       autoClose: type === "error" ? 3000 : 2000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       theme: "colored",
//     });
//   };

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     // Clear error when user types
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     // Clear previous errors
//     setErrors({
//       email: "",
//       password: "",
//     });

//     // Validation
//     let isValid = true;
//     const newErrors = {
//       email: "",
//       password: "",
//     };

//     if (!formData.email) {
//       newErrors.email = "Email is required";
//       isValid = false;
//     } else if (!validateEmail(formData.email)) {
//       newErrors.email = "Please enter a valid email";
//       isValid = false;
//     }

//     if (!formData.password) {
//       newErrors.password = "Password is required";
//       isValid = false;
//     } else if (formData.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//       isValid = false;
//     }

//     if (!isValid) {
//       setErrors(newErrors);
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/users/login`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           timeout: 10000,
//         }
//       );

//       const { user, token } = response.data;

//       localStorage.setItem("user", JSON.stringify(user));
//       localStorage.setItem("token", token);

//       showToast("Login successful!", "success");

//       const redirectPath = user.role === "admin" ? "/dashboard" : "/dashboard";
//       navigate(redirectPath);
//     } catch (error) {
//       let errorMessage = "Login failed. Please try again.";

//       if (axios.isAxiosError(error)) {
//         if (error.response) {
//           // Handle 401 Unauthorized (Invalid credentials)
//           if (error.response.status === 401) {
//             errorMessage = "Invalid email or password. Please try again.";
//             // Highlight the fields to indicate error
//             setErrors({
//               email: "Invalid credentials",
//               password: "Invalid credentials",
//             });
//           } else {
//             errorMessage = error.response.data?.message || errorMessage;
//           }
//         } else if (error.request) {
//           errorMessage = "Network error. Please check your connection.";
//         }
//       } else {
//         console.error("Login Error:", error);
//       }

//       showToast(errorMessage);
//       // Clear password field on error for security
//       setFormData((prev) => ({ ...prev, password: "" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSignUpRedirect = () => navigate("/signUp");
//   const handleForgotPasswordRedirect = () => navigate("/forgot-password");

//   return (
//     <div className="w-full min-h-screen grid grid-cols-1">
//       <div
//         className="flex w-full justify-center items-center p-10 bg-cover bg-center"
//         style={{ backgroundImage: `url(${lgnBg})` }}
//       >
//         <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
//           <div className="flex justify-center items-center pb-8">
//             <img src={logo} alt="logo" className="w-15 h-15" />
//           </div>

//           <h2 className="text-2xl font-semibold text-center mb-1">
//             Welcome Back
//           </h2>
//           <p className="text-gray-500 text-center mb-6">
//             Enter your credentials to access your account
//           </p>

//           <form onSubmit={handleLogin} className="space-y-4">
//             <div>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                   errors.email ? "border-red-500 focus:ring-red-400" : "focus:ring-blue-400"
//                 }`}
//                 required
//               />
//               {errors.email && (
//                 <p className="text-red-500 text-sm mt-1">{errors.email}</p>
//               )}
//             </div>
//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 placeholder="Password"
//                 value={formData.password}
//                 onChange={handleInputChange}
//                 className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                   errors.password ? "border-red-500 focus:ring-red-400" : "focus:ring-blue-400"
//                 }`}
//                 required
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 className="absolute right-3 top-2 text-gray-600"
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//               </button>
//               {errors.password && (
//                 <p className="text-red-500 text-sm mt-1">{errors.password}</p>
//               )}
//             </div>

//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <input type="checkbox" id="remember" className="mr-2" />
//                 <label htmlFor="remember" className="text-sm text-gray-700">
//                   Remember Me
//                 </label>
//               </div>
//               <button
//                 type="button"
//                 className="text-sm text-red-600 hover:underline"
//                 onClick={handleForgotPasswordRedirect}
//               >
//                 Forgot Password?
//               </button>
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className={`w-full ${
//                 loading
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-primary hover:bg-btnHover"
//               } text-white py-2 rounded-md transition duration-200`}
//             >
//               {loading ? "Logging in..." : "Log in"}
//             </button>
//           </form>

//           <div className="text-center mt-4">
//             <span className="text-gray-600">Don't have an account? </span>
//             <button
//               onClick={handleSignUpRedirect}
//               className="text-blue-600 hover:underline"
//             >
//               Register
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import lgnBg from "../../Assets/Login/bgcolor.jpg";
import logo from "../../Assets/Logos/logov.png";
import { loginValidationSchema } from "../../Validations/loginValidation";
import { updateProfileImageInStorage } from "../../utils/profileImageUtils"; // ← add this

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };

  const handleLogin = async (values, { setSubmitting, setFieldError }) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/login`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const { user, token } = data;

      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
      updateProfileImageInStorage(user.profileImage); // ← add this line
      sessionStorage.removeItem("panServiceModalShown");
      toast.success("Login successful!");
      navigate("/dashboard");
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Login failed. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full min-h-screen grid grid-cols-1">
      <div
        className="flex w-full justify-center items-center p-10 bg-cover bg-center"
        style={{ backgroundImage: `url(${lgnBg})` }}
      >
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
          <div className="flex justify-center items-center pb-8">
            <img src={logo} alt="logo" className="w-15 h-15" />
          </div>

          <h2 className="text-2xl font-semibold text-center mb-1">
            Welcome Back
          </h2>
          <p className="text-gray-500 text-center mb-6">
            Enter your credentials to access your account
          </p>

          <Formik
            initialValues={initialValues}
            validationSchema={loginValidationSchema}
            onSubmit={handleLogin}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form className="space-y-4">
                <div>
                  <Field
                    type="email"
                    name="email"
                    placeholder="Email"
                    className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.email && touched.email
                        ? "border-red-500 focus:ring-red-400"
                        : "focus:ring-blue-400"
                    }`}
                  />
                  <ErrorMessage
                    name="email"
                    component="p"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div className="relative">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                      errors.password && touched.password
                        ? "border-red-500 focus:ring-red-400"
                        : "focus:ring-blue-400"
                    }`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-2 text-gray-600"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                  <ErrorMessage
                    name="password"
                    component="p"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input type="checkbox" id="remember" className="mr-2" />
                    <label htmlFor="remember" className="text-sm text-gray-700">
                      Remember Me
                    </label>
                  </div>
                  <button
                    type="button"
                    className="text-sm text-red-600 hover:underline"
                    onClick={() => navigate("/forgot-password")}
                  >
                    Forgot Password?
                  </button>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full ${
                    isSubmitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-primary hover:bg-btnHover"
                  } text-white py-2 rounded-md transition duration-200`}
                >
                  {isSubmitting ? "Logging in..." : "Log in"}
                </button>
              </Form>
            )}
          </Formik>

          <div className="text-center mt-4">
            <span className="text-gray-600">Don't have an account? </span>
            <button
              onClick={() => navigate("/signUp")}
              className="text-blue-600 hover:underline"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
